module.exports = __webpack_public_path__ + "img/mauritius.9cfefa35.png";